// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file staticassets/v1/static_assets.proto (package staticassets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc, serviceDesc } from '@bufbuild/protobuf/codegenv2'
import { file_common_v1_annotations } from '../../common/v1/annotations_pb'
import type { PaginationArguments, PaginationPageInfo } from '../../common/v1/pagination_pb'
import { file_common_v1_pagination } from '../../common/v1/pagination_pb'
import type { Creator } from '../../common/v1/types_pb'
import { file_common_v1_types } from '../../common/v1/types_pb'
import type { FieldMask, Timestamp } from '@bufbuild/protobuf/wkt'
import {
  file_google_protobuf_field_mask,
  file_google_protobuf_struct,
  file_google_protobuf_timestamp
} from '@bufbuild/protobuf/wkt'
import type { JsonObject, Message } from '@bufbuild/protobuf'

/**
 * Describes the file staticassets/v1/static_assets.proto.
 */
export const file_staticassets_v1_static_assets: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_common_v1_annotations,
      file_common_v1_pagination,
      file_common_v1_types,
      file_google_protobuf_struct,
      file_google_protobuf_timestamp,
      file_google_protobuf_field_mask
    ]
  )

/**
 * @generated from message staticassets.v1.GetUploadUrlRequest
 */
export type GetUploadUrlRequest = Message<'staticassets.v1.GetUploadUrlRequest'> & {
  /**
   * @generated from field: optional google.protobuf.Struct metadata = 1;
   */
  metadata?: JsonObject
}

/**
 * Describes the message staticassets.v1.GetUploadUrlRequest.
 * Use `create(GetUploadUrlRequestSchema)` to create a new message.
 */
export const GetUploadUrlRequestSchema: GenMessage<GetUploadUrlRequest> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 0)

/**
 * @generated from message staticassets.v1.GetUploadUrlResponse
 */
export type GetUploadUrlResponse = Message<'staticassets.v1.GetUploadUrlResponse'> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string

  /**
   * @generated from field: string upload_url = 2;
   */
  uploadUrl: string

  /**
   * @generated from field: map<string, string> headers = 3;
   */
  headers: { [key: string]: string }

  /**
   * @generated from field: string id = 4;
   */
  id: string
}

/**
 * Describes the message staticassets.v1.GetUploadUrlResponse.
 * Use `create(GetUploadUrlResponseSchema)` to create a new message.
 */
export const GetUploadUrlResponseSchema: GenMessage<GetUploadUrlResponse> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 1)

/**
 * @generated from message staticassets.v1.StaticAsset
 */
export type StaticAsset = Message<'staticassets.v1.StaticAsset'> & {
  /**
   * ID is the unique identifier of the static asset.
   *
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * Name is the user-provided name for the static asset.
   *
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * Description is an optional description of the static asset.
   *
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * Org ID is the organization that the static asset belongs to.
   *
   * @generated from field: string org_id = 4;
   */
  orgId: string

  /**
   * Workspace ID is the workspace that the static asset belongs to. Must be associated with the org_id.
   *
   * @generated from field: string workspace_id = 5;
   */
  workspaceId: string

  /**
   * Creator is the person who created the static asset.
   *
   * @generated from field: common.v1.Creator creator = 6;
   */
  creator?: Creator

  /**
   * State respresents the current state of the static asset. Valid values are active, archived or draft.
   *
   * @generated from field: string state = 7;
   */
  state: string

  /**
   * The name of the actual file uploaded.
   *
   * @generated from field: string file_name = 8;
   */
  fileName: string

  /**
   * The size of the file uploaded.
   *
   * @generated from field: float file_size = 9;
   */
  fileSize: number

  /**
   * The mime type of the uploaded file.
   *
   * @generated from field: string mime_type = 10;
   */
  mimeType: string

  /**
   * The id of the static asset entry created on file uploaded.
   *
   * @generated from field: string static_asset_id = 11;
   */
  staticAssetId: string

  /**
   * The upload url in storage associated with the uploaded file.
   *
   * @generated from field: string upload_url = 12;
   */
  uploadUrl: string

  /**
   * Created At is the timestamp when the static asset was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp

  /**
   * Updated At is the timestamp when the static asset was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: Timestamp
}

/**
 * Describes the message staticassets.v1.StaticAsset.
 * Use `create(StaticAssetSchema)` to create a new message.
 */
export const StaticAssetSchema: GenMessage<StaticAsset> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 2)

/**
 * @generated from message staticassets.v1.CreateStaticAssetRequest
 */
export type CreateStaticAssetRequest = Message<'staticassets.v1.CreateStaticAssetRequest'> & {
  /**
   * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
   */
  staticAsset?: StaticAsset
}

/**
 * Describes the message staticassets.v1.CreateStaticAssetRequest.
 * Use `create(CreateStaticAssetRequestSchema)` to create a new message.
 */
export const CreateStaticAssetRequestSchema: GenMessage<CreateStaticAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 3)

/**
 * @generated from message staticassets.v1.CreateStaticAssetResponse
 */
export type CreateStaticAssetResponse = Message<'staticassets.v1.CreateStaticAssetResponse'> & {
  /**
   * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
   */
  staticAsset?: StaticAsset
}

/**
 * Describes the message staticassets.v1.CreateStaticAssetResponse.
 * Use `create(CreateStaticAssetResponseSchema)` to create a new message.
 */
export const CreateStaticAssetResponseSchema: GenMessage<CreateStaticAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 4)

/**
 * @generated from message staticassets.v1.ListStaticAssetsRequest
 */
export type ListStaticAssetsRequest = Message<'staticassets.v1.ListStaticAssetsRequest'> & {
  /**
   * Org ID is the organization that the static assets belong to.
   *
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * Workspace ID is the workspace that the static assets belong to. Must be associated with the org_id.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string

  /**
   * Show only static assets created by this creator id.
   *
   * @generated from field: string creator_id = 3;
   */
  creatorId: string

  /**
   * Show only static assets that include this prefix in the name.
   *
   * @generated from field: string name_prefix = 4;
   */
  namePrefix: string

  /**
   * Show only static assets scoped to the requested asset states.
   *
   * @generated from field: repeated string states = 6;
   */
  states: string[]

  /**
   * Pagination arguments.
   *
   * @generated from field: common.v1.PaginationArguments pagination = 5;
   */
  pagination?: PaginationArguments

  /**
   * Show only static assets scoped to the requested categories
   *
   * @generated from field: repeated string categories = 7;
   */
  categories: string[]
}

/**
 * Describes the message staticassets.v1.ListStaticAssetsRequest.
 * Use `create(ListStaticAssetsRequestSchema)` to create a new message.
 */
export const ListStaticAssetsRequestSchema: GenMessage<ListStaticAssetsRequest> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 5)

/**
 * @generated from message staticassets.v1.ListStaticAssetsResponse
 */
export type ListStaticAssetsResponse = Message<'staticassets.v1.ListStaticAssetsResponse'> & {
  /**
   * List of static assets that match the query.
   *
   * @generated from field: repeated staticassets.v1.StaticAsset static_assets = 1;
   */
  staticAssets: StaticAsset[]

  /**
   * Pagination information.
   *
   * @generated from field: common.v1.PaginationPageInfo page_info = 2;
   */
  pageInfo?: PaginationPageInfo
}

/**
 * Describes the message staticassets.v1.ListStaticAssetsResponse.
 * Use `create(ListStaticAssetsResponseSchema)` to create a new message.
 */
export const ListStaticAssetsResponseSchema: GenMessage<ListStaticAssetsResponse> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 6)

/**
 * @generated from message staticassets.v1.UpdateStaticAssetRequest
 */
export type UpdateStaticAssetRequest = Message<'staticassets.v1.UpdateStaticAssetRequest'> & {
  /**
   * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
   */
  staticAsset?: StaticAsset

  /**
   * @generated from field: google.protobuf.FieldMask mask = 2;
   */
  mask?: FieldMask
}

/**
 * Describes the message staticassets.v1.UpdateStaticAssetRequest.
 * Use `create(UpdateStaticAssetRequestSchema)` to create a new message.
 */
export const UpdateStaticAssetRequestSchema: GenMessage<UpdateStaticAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 7)

/**
 * @generated from message staticassets.v1.UpdateStaticAssetResponse
 */
export type UpdateStaticAssetResponse = Message<'staticassets.v1.UpdateStaticAssetResponse'> & {
  /**
   * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
   */
  staticAsset?: StaticAsset
}

/**
 * Describes the message staticassets.v1.UpdateStaticAssetResponse.
 * Use `create(UpdateStaticAssetResponseSchema)` to create a new message.
 */
export const UpdateStaticAssetResponseSchema: GenMessage<UpdateStaticAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 8)

/**
 * @generated from message staticassets.v1.GetStaticAssetRequest
 */
export type GetStaticAssetRequest = Message<'staticassets.v1.GetStaticAssetRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message staticassets.v1.GetStaticAssetRequest.
 * Use `create(GetStaticAssetRequestSchema)` to create a new message.
 */
export const GetStaticAssetRequestSchema: GenMessage<GetStaticAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 9)

/**
 * @generated from message staticassets.v1.GetStaticAssetResponse
 */
export type GetStaticAssetResponse = Message<'staticassets.v1.GetStaticAssetResponse'> & {
  /**
   * @generated from field: staticassets.v1.StaticAsset static_asset = 1;
   */
  staticAsset?: StaticAsset
}

/**
 * Describes the message staticassets.v1.GetStaticAssetResponse.
 * Use `create(GetStaticAssetResponseSchema)` to create a new message.
 */
export const GetStaticAssetResponseSchema: GenMessage<GetStaticAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 10)

/**
 * @generated from message staticassets.v1.DeleteStaticAssetRequest
 */
export type DeleteStaticAssetRequest = Message<'staticassets.v1.DeleteStaticAssetRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message staticassets.v1.DeleteStaticAssetRequest.
 * Use `create(DeleteStaticAssetRequestSchema)` to create a new message.
 */
export const DeleteStaticAssetRequestSchema: GenMessage<DeleteStaticAssetRequest> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 11)

/**
 * @generated from message staticassets.v1.DeleteStaticAssetResponse
 */
export type DeleteStaticAssetResponse = Message<'staticassets.v1.DeleteStaticAssetResponse'> & {}

/**
 * Describes the message staticassets.v1.DeleteStaticAssetResponse.
 * Use `create(DeleteStaticAssetResponseSchema)` to create a new message.
 */
export const DeleteStaticAssetResponseSchema: GenMessage<DeleteStaticAssetResponse> =
  /*@__PURE__*/
  messageDesc(file_staticassets_v1_static_assets, 12)

/**
 * @generated from service staticassets.v1.StaticAssetsService
 */
export const StaticAssetsService: GenService<{
  /**
   * @generated from rpc staticassets.v1.StaticAssetsService.GetUploadUrl
   */
  getUploadUrl: {
    methodKind: 'unary'
    input: typeof GetUploadUrlRequestSchema
    output: typeof GetUploadUrlResponseSchema
  }
  /**
   * @generated from rpc staticassets.v1.StaticAssetsService.CreateStaticAsset
   */
  createStaticAsset: {
    methodKind: 'unary'
    input: typeof CreateStaticAssetRequestSchema
    output: typeof CreateStaticAssetResponseSchema
  }
  /**
   * @generated from rpc staticassets.v1.StaticAssetsService.ListStaticAssets
   */
  listStaticAssets: {
    methodKind: 'unary'
    input: typeof ListStaticAssetsRequestSchema
    output: typeof ListStaticAssetsResponseSchema
  }
  /**
   * @generated from rpc staticassets.v1.StaticAssetsService.UpdateStaticAsset
   */
  updateStaticAsset: {
    methodKind: 'unary'
    input: typeof UpdateStaticAssetRequestSchema
    output: typeof UpdateStaticAssetResponseSchema
  }
  /**
   * @generated from rpc staticassets.v1.StaticAssetsService.GetStaticAsset
   */
  getStaticAsset: {
    methodKind: 'unary'
    input: typeof GetStaticAssetRequestSchema
    output: typeof GetStaticAssetResponseSchema
  }
  /**
   * @generated from rpc staticassets.v1.StaticAssetsService.DeleteStaticAsset
   */
  deleteStaticAsset: {
    methodKind: 'unary'
    input: typeof DeleteStaticAssetRequestSchema
    output: typeof DeleteStaticAssetResponseSchema
  }
}> = /*@__PURE__*/ serviceDesc(file_staticassets_v1_static_assets, 0)
